import * as React                                     from 'react';
import { LocalStorageService, SessionStorageService } from 'ts-storage-service';
import { useTranslation }                             from 'react-i18next';

import { nowBetweenDates } from '../../../common/tools';

import { useModal }  from '../../providers/modal';
import { useCommon } from '../../providers/common';

const Notification = function() {
  const { t } = useTranslation();

  const common = useCommon();
  const modal  = useModal();

  const ls = new LocalStorageService('notification');
  const ss = new SessionStorageService('notification');

  const checkIsShowed      = React.useCallback((notification) => {
    if (nowBetweenDates(notification.activeFrom.date, notification.activeTo.date)) {
      const storage = notification.behavior === 1 ? ls : ss;

      const { wasOpened } = storage.getData(`${notification.notificationId}`) || {};

      if (!wasOpened) {
        storage.setData(`${notification.notificationId}`, { wasOpened: true }, new Date(notification.activeTo.date));

        return true;
      }
    }

    return false;
  }, []);
  const renderNotification = React.useCallback((props) => {
    const {
            hideModal,
            notification,
          } = props;

    let parsedDescription;

    try {
      parsedDescription = JSON.parse(notification.description);
    } catch (e) {
      parsedDescription = {};
    }

    const hasSections = parsedDescription.SECTIONS && parsedDescription.SECTIONS.length > 0;

    return (
      <div className={'notification_container'}>
        {hasSections && (
          <div
            dangerouslySetInnerHTML={{ __html: notification.description }}
            style={{ marginBottom: '20px' }}
          />
        )}
        {typeof notification.urlLabel === 'string' && typeof notification.urlKey === 'string' && notification.urlKey && (
          <a
            className={'btn fill'}
            dangerouslySetInnerHTML={{ __html: notification.urlLabel ?? t('more_details') }}
            href={notification.urlKey}
            onClick={hideModal}
            rel={'noreferrer, noopener'}
          />
        )}
      </div>
    );
  }, []);
  const showNotification   = React.useCallback(() => {
    const notification = common.notifications.find(checkIsShowed);

    if (notification) {
      modal.showModal(notification.label, {
        component: renderNotification,
        props:     {
          hideModal: () => {
            modal.hideModal();

            showNotification();
          },
          notification,
          onClose:   showNotification,
        },
      }, false, 'notification_modal');
    }
  }, [checkIsShowed, common.notifications, renderNotification]);

  React.useEffect(() => {
    showNotification();
  }, []);

  return null;
};

export default Notification;